import React from 'react';

const Vue_Build = () => {
  return (
    <div>
      <h1>Vue_Build Component</h1>
      <p>This is the Vue_Build tutorial page.</p>
    </div>
  );
}

export default Vue_Build;
